function makeIdFormatting(str) {
  return str.toLowerCase().replaceAll(' ', '-').slice(0, -1);
}

export const createTabID = (str, i) => `${makeIdFormatting(str)}-${i + 1}`;

export const createPanelID = (str, i) => `${makeIdFormatting(str)}-panel-${i + 1}`;
